import isEqual from "lodash.isequal";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export const usePreApplyWhereQuery = <WHERE>() => {
  const { query, isReady } = useRouter();
  const [preApplyWhere, setPreApplyWhere] = useState<WHERE>();

  useEffect(() => {
    const whereQueryObject = JSON.parse(
      decodeURI((query?.where ?? "{}") as string),
    );
    if (!isReady || isEqual(preApplyWhere, whereQueryObject)) return;
    setPreApplyWhere(whereQueryObject);
  }, [isReady, query]);

  return { preApplyWhere, setPreApplyWhere };
};
